// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invResourceId } from './InvResource';
import { invLocationId } from './InvLocation';
import { calendarDate } from '../../calendar-date';
import { invItemOriginEnum } from './InvItemOriginEnum';
import { invPurchaseOrderItemId } from './InvPurchaseOrderItem';
import { invQuantityUnitEnum } from './InvQuantityUnitEnum';
import { invProductId } from './InvProduct';
import { invSupplierId } from './InvSupplier';
import { z } from 'zod';
export const invItemId = (z.number());
export const invItem = z.object({
    id: invItemId,
    resource_id: invResourceId.nullable(),
    location_id: invLocationId.nullable(),
    lot_number: z.string().nullable(),
    expiry_date: calendarDate.nullable(),
    date_added: calendarDate.nullable(),
    created_at: z.date().nullable(),
    updated_at: z.date().nullable(),
    origin_type: invItemOriginEnum,
    purchase_order_item_id: invPurchaseOrderItemId.nullable(),
    current_quantity: z.number(),
    quantity_unit: invQuantityUnitEnum,
    product_id: invProductId.nullable(),
    name: z.string().nullable(),
    is_non_depleting: z.boolean(),
    supplier_id: invSupplierId.nullable(),
    tare_g: z.string().nullable(),
});
export const invItemInitializer = z.object({
    id: invItemId.optional(),
    resource_id: invResourceId.optional().nullable(),
    location_id: invLocationId.optional().nullable(),
    lot_number: z.string().optional().nullable(),
    expiry_date: calendarDate.optional().nullable(),
    date_added: calendarDate.optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
    origin_type: invItemOriginEnum,
    purchase_order_item_id: invPurchaseOrderItemId.optional().nullable(),
    current_quantity: z.number(),
    quantity_unit: invQuantityUnitEnum,
    product_id: invProductId.optional().nullable(),
    name: z.string().optional().nullable(),
    is_non_depleting: z.boolean().optional(),
    supplier_id: invSupplierId.optional().nullable(),
    tare_g: z.string().optional().nullable(),
});
export const invItemMutator = z.object({
    id: invItemId.optional(),
    resource_id: invResourceId.optional().nullable(),
    location_id: invLocationId.optional().nullable(),
    lot_number: z.string().optional().nullable(),
    expiry_date: calendarDate.optional().nullable(),
    date_added: calendarDate.optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
    origin_type: invItemOriginEnum.optional(),
    purchase_order_item_id: invPurchaseOrderItemId.optional().nullable(),
    current_quantity: z.number().optional(),
    quantity_unit: invQuantityUnitEnum.optional(),
    product_id: invProductId.optional().nullable(),
    name: z.string().optional().nullable(),
    is_non_depleting: z.boolean().optional(),
    supplier_id: invSupplierId.optional().nullable(),
    tare_g: z.string().optional().nullable(),
});
//# sourceMappingURL=InvItem.js.map